export default __webpack_public_path__ + "static/media/testimonial-img-11.84b079ad.jpg";